// extracted by mini-css-extract-plugin
export default {"wrapper":"dhbrm__wrapper--f2b63","image":"dhbrm__image--a0cb3"};